// =========================
// EVENT CARD COMPONENT
// =========================

// External Libraries
import { LitElement, html, css } from 'lit';

// App Modules
import { gotoRoute } from './../Router';
import App from './../App';
import Utils from '../Utils';

// This component displays a card for an event
class PopinEventCard extends LitElement {
  static properties = {
    event: { type: Object },
  };

  constructor() {
    super();
    this.event = null;
  }

  // LIFECYCLE METHODS

  // This method is called when the component is clicked
  // It navigates to the event details page
  handleCardClick() {
    gotoRoute(`/event?id=${this.event._id}`);
  }

  render() {
    if (!this.event) return;

    const { title, location, dateTime, category, eventImage } = this.event;

    const imageSrc = eventImage
      ? `${App.apiBase}/uploads/${eventImage}`
      : `${App.apiBase}/static/default-profile-event.png`;

    const formattedDate = new Date(dateTime).toLocaleString(undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    return html`
      <div class="card" @click=${this.handleCardClick}>
        <img class="event-image" src="${imageSrc}" alt="${title}" />
        <div class="title">${title}</div>
        <div class="date">${formattedDate}</div>
        <div class="location">${location}</div>
        <div class="category">${Utils.formatFieldName(category)}</div>
      </div>
    `;
  }

  static styles = css`
    :host {
      display: block;
    }

    .card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      padding: 1rem;
      transition: transform 0.2s;
      cursor: pointer;
    }

    .card:hover {
      transform: translateY(-4px);
    }

    .event-image {
      width: 100%;
      aspect-ratio: 1;
      object-fit: cover;
      border-radius: 8px;
    }

    .title {
      font-size: 1.2rem;
      font-weight: bold;
      margin: 0.75rem 0 0.25rem;
    }

    .date {
      color: var(--sl-color-primary-600);
      font-size: 0.9rem;
    }

    .location {
      font-size: 0.85rem;
      color: #444;
      margin-top: 0.2rem;
    }

    .category {
      font-size: 0.8rem;
      color: #777;
    }
  `;
}

customElements.define('popin-event-card', PopinEventCard);
